(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanosis-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sanosis-testimonials')) {
    customElements.define('sanosis-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sst-track');
        this.nav = this.querySelector('.sst-nav');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        this.querySelectorAll('.sst-arrow').forEach((btn) => {
          btn.addEventListener('click', () => {
            const slide = this.track.querySelector('.sst-slide');
            if (!slide) return;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            this.track.scrollBy({ left: Number(btn.dataset.dir) * (slide.offsetWidth + gap), behavior: 'smooth' });
          });
        });
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.ro && this.ro.disconnect(); }
      update() {
        const t = this.track;
        const overflow = t.scrollWidth > t.clientWidth + 2;
        this.nav.hidden = !overflow;
        this.prev.disabled = t.scrollLeft <= 2;
        this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
